import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	align-items: center;
	column-gap: 4px;
	font-size: 14px;
	margin: 2px 0 0 -3px;
	background-color: transparent;
	line-height: 22px;

	&:empty {
		display: none;
	}
`
